import { render, staticRenderFns } from "./NewServerActive.vue?vue&type=template&id=6d436791&scoped=true&"
import script from "./NewServerActive.vue?vue&type=script&lang=js&"
export * from "./NewServerActive.vue?vue&type=script&lang=js&"
import style0 from "./NewServerActive.vue?vue&type=style&index=0&id=6d436791&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d436791",
  null
  
)

export default component.exports